/**
 * Helper functions for modifying the DOM.
 *
 * @module DomHelper
 * @author EN GARDE
 * @version 1.2
 *
 * @requires lodash
 * @requires jQuery
 * @requires JsHelper
 */

var EN = EN || {};

EN.DomHelper = (function (_, $, JsHelper) {
	'use strict';

	if (!JsHelper.dependencyExists(_, 'lodash', 'DomHelper')) return;
	if (!JsHelper.dependencyExists($, 'jQuery', 'DomHelper')) return;
	if (!JsHelper.dependencyExists(JsHelper, 'JsHelper', 'DomHelper')) return;

	/**
	 * Sets custom capability classes (like `touch` or `no-touch`) to the html element.
	 * @memberof module:DomHelper
	 * @return {jQuery} HTML element
	 */
	var setCapabilityClasses = function () {
		var $root = $(document.documentElement);

		// check for touch – regular touch devices & windows phone (see https://coderwall.com/p/egbgdw)
		if ('ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints) {
			$root.removeClass('no-touch');
			$root.addClass('touch');
		}


		// TODO: There seems to be a bug when trying to access document.body.style. Not resolved yet, which is
		// why I commented this block of code out for now.

		// check for iOS
		// if ('-webkit-overflow-scrolling' in document.body.style) {
		// 	$root.addClass('ios');
		// }
		// else {
		// 	$root.addClass('no-ios');
		// }

		$root.removeClass('no-js');
		$root.addClass('js');

		return $root;
	};

	/**
	 * Read values from a form and returns them as a (nested) object
	 * @memberof module:DomHelper
	 * @return {object} form data
	 */
	var getFormData = function($form) {
		return JsHelper.deserializeQueryString($form.serialize());
	};

	/**
	 * Update form elements using a data object. Opposite of getFormData()
	 * @memberof module:DomHelper
	 * @param {jQuery} $scope=$(document) only change fields in this scope
	 * @param {object} data form data
	 * @param {boolean} reset data that is not set in form data object
	 */
	var setFormData = function($scope, data, force) {
		$scope = $scope || $(document);
		data = data || {};
		force = force === false ? false : true;

		var $fields = $scope.find(':input[name]');

		$fields.each(function(i, elem) {
			var $elem = $(elem);
			var type = $elem.attr('type');
			var name = $elem.attr('name');
			var nameClean = name;
			var isArrayLikeValue = name.lastIndexOf('[]') === name.length - 2;
			if (isArrayLikeValue) nameClean = name.substr(0, name.lastIndexOf('[]'));

			var value = $elem.val();
			var fieldData = _.get(data, nameClean);

			switch(type) {
				case 'radio':
				case 'checkbox':
					if (isArrayLikeValue && _.isArray(fieldData) && _.indexOf(fieldData, value) !== -1) {
						$elem.prop('checked', true);
					}
					else if (!isArrayLikeValue && fieldData === value) {
						$elem.prop('checked', true);
					}
					else {
						if (force) $elem.prop('checked', false);
					}
					break;
				default:
					if (fieldData) $elem.val(fieldData);
					else if (force) $elem.val('');
			}
		});
	};

	/**
	 * Add highlander functionality for checkboxes sharing the same highland attribute (e.g. "name")
	 * use data-en-highlander on the input[type=checkbox]
	 * @memberof module:DomHelper
	 * @param {jQuery} $scope=$(document) only change fields in this scope
	 * @param {object} options={}
	 * @property {string} selector='input[type=checkbox]' selector for checkboxes
	 * @property {string} attribute='data-en-highlander' data attribute that enabled highlanding
	 * @property {string} highland='name' data attribute to search others by
	 */
	var initCheckboxHighlander = function($scope, options) {
		$scope = $scope || $(document);
		options = _.defaultsDeep(options, {
			selector: 'input[type=checkbox]',
			attribute: 'data-en-highlander',
			highland: 'name'
		});

		$scope.on('change', options.selector, function(e) {
			var $input = $(this);
			var status = $input.prop('checked');

			if (status !== true) return; // do nothing when disabling the checkbox
			if ($input.attr(options.attribute) === undefined) return; // no highlander

			var name = $input.attr(options.highland);
			var $others = $scope.find('[name="' + name + '"]').not($input);
			$others.each(function() {
				var $other = $(this);
				var isChecked = !!$other.prop('checked');
				$other.prop('checked', false);
				if (isChecked) $other.trigger('change'); // trigger change event only if the property really changes
			});
		});
	};

	return {
		setCapabilityClasses: setCapabilityClasses,
		getFormData: getFormData,
		setFormData: setFormData,
		initCheckboxHighlander: initCheckboxHighlander
	};
}(lodash, jQuery, EN.JsHelper));
